
define('ldsh!modules/form_editor/templates/element', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group js-label-group-id">\n  <label for="" data-i18n="formEditor.elementId"></label>\n  <input type="text" name="idElement" class="form-control js-element-id" value="' +
((__t = ( elementId )) == null ? '' : __t) +
'" required>\n  ';
 if (!elementId || !(elementId.match(/[A-Z0-9]/gi))){ ;
__p += '\n    <span class=\'error\' data-i18n="editor.idRequiredAndValid"></span>\n  ';
 } ;
__p += '\n</div>\n';
 if (!isHiddenField) { ;
__p += '\n  <div class="ed-form-group js-label-group-label">\n    <label for="" data-i18n="formEditor.label"></label>\n    <input type="text" name="label" class="form-control js-label" value="' +
((__t = ( labelText )) == null ? '' : __t) +
'" data-i18n="[placeholder]landingPage.name" placeholder="Nombre">\n  </div>\n  <div class="ed-form-group flex mt12 justify-space-between ">\n    ';
 if (!isTermsElement) { ;
__p += '\n      <div class="md__checkbox--wrapper">\n        <input\n          id="js-hidelabel"\n          type="checkbox"\n          class="md__checkbox--primary js-filter-hidden js-hidelabel"\n          ' +
((__t = ( isLabelHidden && "checked" )) == null ? '' : __t) +
'\n        />\n        <label\n          for="js-hidelabel"\n          data-i18n="formEditor.hideLabel"\n        ></label>\n      </div>\n    ';
 } ;
__p += '\n\n    <div class="md__checkbox--wrapper">\n      <input\n        id="js-required"\n        type="checkbox"\n        class="md__checkbox--primary js-filter-hidden js-required"\n        ' +
((__t = ( isRequired )) == null ? '' : __t) +
' ' +
((__t = ((isRequiredReadOnly) ? 'checked disabled="disabled"' : '')) == null ? '' : __t) +
'\n      />\n      <label\n        for="js-required"\n        data-i18n="formEditor.isRequired"\n      ></label>\n    </div>\n  </div>\n';
 } ;
__p += '\n';
 if (!isCustomDate) {;
__p += '\n<div class="ed-form-group">\n  <label for="fieldWidth" class="ed-form-group" data-i18n="formEditor.fieldWidth">Ancho</label>\n  <select name="fieldWidth" id="fieldWidth" class="js-field-width">\n    <option value="one-whole" data-i18n="fieldWidthFull">100%</option>\n    <option value="three-quarters" data-i18n="fieldWidthThreeQuarters">75%</option>\n    <option value="two-thirds" data-i18n="fieldWidthTwoThirds">66%</option>\n    <option value="one-half" data-i18n="fieldWidthOneHalf">50%</option>\n    <option value="one-third" data-i18n="fieldWidthOneThird">33%</option>\n    <option value="one-quarter" data-i18n="fieldWidthOneQuarter">25%</option>\n  </select>\n</div>\n';
 } ;
__p += '\n';

}
return __p
};});

